(function () {
  angular.module('kareo.ui.shared.directives.billing-workflow', [
    'kareo.ui.shared.modules.billingWorkflow',
    'kareo.ui.shared.modules'])
    .directive('billingWorkflow', [function () {
      return {
        template: require('./billing-workflow.pug')(),
        restrict: 'E',
        controller: ['$scope', '$window', 'billingWorkflowService', billingWorkflowCtrl]
      };
    }]);

  function billingWorkflowCtrl($scope, $window, billingWorkflowService) {
    $scope.isActive = isActive;
    $scope.getNavigationURL = getNavigationURL;
    $scope.stepEnabled = stepEnabled;

    billingWorkflowService.getBillingTasksCount().then((count) => {
      $scope.tasksCount = count;
    });

    function isActive(stepName) {
      return ($window.location.href.indexOf(billingWorkflowService.getURLFor(stepName)) > 0);
    }

    function stepEnabled(stepName) {
      return billingWorkflowService.stepEnabled(stepName);
    }

    function getNavigationURL(stepName) {
      return billingWorkflowService.getURLFor(stepName) + '?view=billing-workflow';
    }
  }
})();
